import React from "react";
import Tabs from "@common/Tabs";
import Tab from "@common/Tab";
import ContentImport from "./ContentImport";
import ContentStylesEditor from "./ContentStylesEditior/ContentStylesEditor";

const ContentTabs = props => {
    const TABS = {
        CONTENT_IMPORT: {val: 0, hash: 'import'},
        STYLES_EDITOR: {val: 1, hash: 'styles'}
    }

    return (
        <Tabs activeKey={TABS.CONTENT_IMPORT.val} variant="standard">
            <Tab tab={'Import'} key={TABS.CONTENT_IMPORT.val} hash={TABS.CONTENT_IMPORT.hash} children={
                <ContentImport />
            }/>
            <Tab tab={'Styles'} key={TABS.STYLES_EDITOR.val} hash={TABS.STYLES_EDITOR.hash} children={
                <ContentStylesEditor />
            }/>
        </Tabs>
    )
}

export default ContentTabs;